import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { img1, img2 } from "../../assets/img/imgIndex";
import { useLocation, useNavigate } from "react-router-dom";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";

const FoodsManagementView = () => {
  const location = useLocation();
  const { id, tab, page } = location.state ?? {};
  const navigate = useNavigate();

  const [form, setForm] = useState([
    { id: 1, name: "Food Images", value: [img1, img2], type: "img" },
    { id: 2, name: "Food ID", value: "", type: "input" },
    { id: 3, name: "Food Name", value: "", type: "input" },
    { id: 4, name: "Food Type", value: "", type: "input" },
    { id: 5, name: "Seller Name", value: "", type: "input" },
    // { id: 6, name: "Order Type", value: "", type: "input" },
    { id: 7, name: "Payment Type", value: "", type: "input" },
    { id: 8, name: "Quantity", value: "", type: "input" },
    { id: 9, name: "Qty Price", value: "", type: "input" },
    { id: 10, name: "Delivery Type", value: "", type: "input" },
    { id: 11, name: "Delivery Location", value: "", type: "input" },
    { id: 12, name: "Description", value: "", type: "desc" },
    { id: 13, name: "Posted Date & Time", value: "", type: "input" },
    { id: 14, name: "Food Available at", value: "", type: "input" },
    ...(tab == 2
      ? [{ id: 15, name: "Expired Date & Time", value: "", type: "input" }]
      : []),
  ]);

  // console.log("tabValue---->", tab);
  console.log("id", id);

  const fetchData = async (id) => {
    let payload = {
      food_id: id,
    };
    let res = await post(URLS.FOOD_VIEW, payload);
    if (res?.status == "success") {
      let d = res?.data;
      setForm((prev) =>
        prev.map((i) => {
          switch (i.id) {
            case 1:
              return {
                ...i,
                value: d?.images || [],
              };
            case 2:
              return {
                ...i,
                value: d?.food_id,
              };
            case 3:
              return {
                ...i,
                value: d?.food_name,
              };
            case 4:
              return {
                ...i,
                value: d?.food_type == 0 ? "Veg" : "Non-veg",
              };
            case 5:
              return {
                ...i,
                value: d?.seller_name,
              };
            // case 6:
            //   return {
            //     ...i,
            //     // value:
            //     //   d?.booking_type === "Pre Booking" ||
            //     //     d?.booking_type === 1 ||
            //     //     d?.booking_type === "1"
            //     //     ? "Pre Booking"
            //     //     : String(d?.booking_type ?? ""),
            //     value: d?.road_distance_km ? `${d.road_distance_km} km` : "",
            //   };
            case 7:
              return {
                ...i,
                value:
                  d?.payment_type == 0
                    ? "Free"
                    : d?.payment_type == 1
                      ? "Paid"
                      : "Special Recipe",
              };
            case 8:
              return {
                ...i,
                value: d?.quantity,
              };
            case 9:
              return {
                ...i,
                value: String(d?.price),
              };
            case 10:
              return {
                ...i,
                value: d?.delivery_type == 0 ? "Takeaway" : "Delivery",
              };
            case 11:
              return {
                ...i,
                value: `${String(d?.latitude)},${String(d?.longitude)}`,
              };

            case 12:
              return {
                ...i,
                value: d?.description,
              };
            case 13:
              return {
                ...i,
                value: moment(d?.posted_at).format("DD-MM-YYYY,h:mm A") ?? "-",
              };
            case 14:
              return {
                ...i,
                value: d?.available_at
                  ? moment(d?.available_at).format("DD-MM-YYYY,h:mm A")
                  : "-",
              };

            case 15:
              return {
                ...i,
                value:
                  moment(d?.available_at)
                    .add(1, "hour")
                    .format("DD-MM-YYYY,h:mm A") ?? "-",
              };

            default:
              return i;
          }
        })
      );
    }
  };

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, []);

  const isPreBooking =
    form.find((item) => item.id === 6)?.value === "Pre Booking";

  return (
    <div>
      <PageHeader
        title={tab == 1 ? "Available Food" : "Expired Food"}
        showBackButton={true}
        onBackClick={() =>
          navigate("/foods", { state: { page: page || 1, tab: tab || 1 } })
        }
      />
      <div className="form-grid">
        {form.map((i) => {
          if (i.id === 14 && !isPreBooking) {
            return null;
          }
          if (i.type === "input") {
            return (
              <div className="form-item" key={i.id}>
                <div className="form-group">
                  <label>{i.name}</label>
                  <input type="text" value={i.value || "-"} readOnly />
                </div>
              </div>
            );
          } else if (i.type === "img") {
            return (
              <div className="form-group" key={i.id}>
                <label>{i.name}</label>
                <div className="img-row">
                  {i.value.map((it, ind) => (
                    <img
                      key={ind}
                      src={it}
                      className="food-img"
                      alt={`Food ${ind + 1}`}
                    />
                  ))}
                </div>
              </div>
            );
          } else if (i.type === "desc") {
            return (
              <div className="form-item full-width" key={i.id}>
                <div className="form-group">
                  <label>{i.name}</label>
                  <textarea
                    value={i.value || "-"}
                    readOnly
                    rows={1}
                    className="desc-textarea"
                  />
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default FoodsManagementView;
